import { AdminRequest } from "./AdminRequest";
import { Logger } from "../logging/Logger";
import { Navigation } from "../Navigation";
import { LogManager } from "../logging/LogManager";

export class OpenUrlRequest extends AdminRequest {
    private static log: Logger = LogManager.getLogger("core.client.OpenUrlRequest");
    relativePath: string;

    constructor(message: any) {
        super(message);
        this.relativePath = message.relativePath;
    }

    override handle(): void {
        OpenUrlRequest.log.debug("Opening URL in new tab: %s", this.relativePath);
        Navigation.navigateTo(this.relativePath, { newTab: true });
    }
}
